const initializedVideos = new WeakSet();
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export const initHeroVideos = (scope = document) => {
    scope.querySelectorAll('[data-hero-video]').forEach((video) => {
        const section = video.closest('.first-sec');
        const button = section?.querySelector('[data-hero-video-toggle]');
        const label = button?.querySelector('[data-hero-video-label]');
        const sources = video.querySelectorAll('source[data-src]');

        if (initializedVideos.has(video) || !button || !label || !sources.length) {
            return;
        }

        initializedVideos.add(video);
        let loaded = false;
        let userPaused = false;

        const updateControl = () => {
            const text = video.paused ? 'Play background video' : 'Pause background video';
            label.textContent = video.paused ? 'Play video' : 'Pause video';
            button.setAttribute('aria-label', text);
            button.setAttribute('title', text);
            button.dataset.paused = String(video.paused);
        };

        const playVideo = () => {
            if (reducedMotion.matches) return;

            if (!loaded) {
                sources.forEach((source) => {
                    source.src = source.dataset.src;
                });
                video.load();
                loaded = true;
            }

            video.play().catch(updateControl);
        };

        const applyMotionPreference = () => {
            button.hidden = reducedMotion.matches;

            if (reducedMotion.matches) {
                video.pause();

                if (loaded) {
                    sources.forEach((source) => source.removeAttribute('src'));
                    video.load();
                    loaded = false;
                }
            } else if (!userPaused) {
                playVideo();
            }

            updateControl();
        };

        button.addEventListener('click', () => {
            userPaused = !video.paused;

            if (userPaused) {
                video.pause();
            } else {
                playVideo();
            }

            updateControl();
        });

        video.addEventListener('play', updateControl);
        video.addEventListener('pause', updateControl);
        reducedMotion.addEventListener('change', applyMotionPreference);
        applyMotionPreference();
    });
};

initHeroVideos();
